import React, { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from "react-router-dom";
import { logOut } from './../util'
import SimpleTextDialog from '../dialogs/simple-text-dialog';

export default function ScheduleMenu({ token, setToken, anchorEl, setAnchorEl, anchorData, setAnchorData, setSelectedScheduleId, setSchedules, setCreateDialogOpen }) {
    let [editNameDialogOpen, setEditNameDialogOpen] = useState(false);
    const open = Boolean(anchorEl);
    let navigate = useNavigate()

    const handleClose = () => {
        setAnchorEl(null);
        setAnchorData(null);
    };

    const handleEditName = () => {
        // setEditNameDialogOpen(true)
        setCreateDialogOpen(true)
    };

    const deleteQrCode = () => {
        fetch('/api/schedules/' + anchorData._id, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            },
        })
            .then(response => {
                if (response.status !== 200) {
                    if (response.status === 401) {
                        logOut({ navigate, setToken })
                    }
                    console.log('Schedule not deleted');
                } else {
                    handleClose()
                    setSchedules(schedules => schedules.filter(s => s._id !== anchorData._id))
                    setSelectedScheduleId(null)
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    return (
        <React.Fragment>
            <Menu
                id="schedule-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem onClick={handleEditName}>Edit</MenuItem>
                <MenuItem onClick={deleteQrCode} sx={{ color: 'firebrick' }}>Delete</MenuItem>
            </Menu>
            <SimpleTextDialog
                token={token}
                setToken={setToken}
                open={editNameDialogOpen}
                setOpen={setEditNameDialogOpen}
                handleCloseExternal={handleClose}
                apiEndpoint={'/api/schedules/' + anchorData?._id}
                value={anchorData}
                setValue={setSchedules}
                dialogTitle={"Edit QR code name"}
                dbFieldname={"name"}
                inputLabel={"Name"}
                entityId={anchorData?._id}
                accountId={anchorData?.accountId}
            />
        </React.Fragment>
    );
}
